import { Controller } from "@hotwired/stimulus"

const FADE_MS = 300

export default class extends Controller {
  static targets = ["item"]

  initialize() {
    this.timers = new WeakMap()
  }

  // Fires for each item target already in DOM at connect time
  // AND for ones appended later (e.g. via Turbo Stream)
  itemTargetConnected(item) {
    const duration = parseInt(item.dataset.toastDuration) || 4000
    this.#startTimer(item, duration)
  }

  itemTargetDisconnected(item) {
    this.#clearTimer(item)
  }

  // data-action="mouseenter->toast#pause"
  pause({ currentTarget }) {
    this.#clearTimer(currentTarget)
  }

  // data-action="mouseleave->toast#resume"
  resume({ currentTarget }) {
    const duration = parseInt(currentTarget.dataset.toastDuration) || 4000
    this.#startTimer(currentTarget, duration)
  }

  // data-action="wa-hide->toast#close"
  close(event) {
    event.preventDefault()
    const item = event.target.closest("[data-toast-target='item']")
    if (item) this.#dismiss(item)
  }

  // ---- private ----

  #startTimer(item, duration) {
    this.#clearTimer(item)
    const id = setTimeout(() => this.#dismiss(item), duration)
    this.timers.set(item, id)
  }

  #clearTimer(item) {
    const id = this.timers.get(item)
    if (id != null) {
      clearTimeout(id)
      this.timers.delete(item)
    }
  }

  #dismiss(item) {
    if (item.classList.contains("app-toast--leaving")) return
    this.#clearTimer(item)
    item.classList.add("app-toast--leaving")
    setTimeout(() => item.remove(), FADE_MS)
  }
}
